<template>
  <div class="news_content">
    <div class="header">
      <h2>{{ news.title }}</h2>
      <div class="createdAt">
        <img src="@/assets/icons/calendar.svg" alt="Calendrier" />
        <span>{{ news.createdAt }}</span>
      </div>
    </div>
    <editor-content :editor="editor" />
    <div v-if="editable">
      <button class="deleteNewsButton" @click="deleteNews" type="button">!! SUPPRIMER !!</button>
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap';
import {
  Blockquote,
  Heading,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Underline,
} from 'tiptap-extensions';

export default {
  name: 'NewsContent',
  props: { editable: Boolean, news: Object },
  components: {
    EditorContent,
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    this.editor = new Editor({
      content: this.news.content,
      editable: false,
      extensions: [
        new BulletList(),
        new Heading({ levels: [2] }),
        new ListItem(),
        new Bold(),
        new Italic(),
        new Underline(),
      ],
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    deleteNews() {
      this.$emit('deleteNews', this.news);
    },
  },
};
</script>

<style lang="scss">
.news_content {
  padding: 16px;
  margin: 16px;
  background-color: rgb(230, 230, 230);
  border-radius: 16px;
  box-shadow: 1px 5px 3px rgb(230, 230, 230);

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: $break-mobile) {
      flex-direction: column;
      align-items: flex-start;
    }

    h2 {
      margin: 8px 0px;
    }
  }

  .createdAt {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 32px;
      height: 32px;

      @media screen and (max-width: $break-large) {
        width: 24px;
        height: 24px;
      }
    }
    span {
      color: rgb(60, 60, 60);
      font-style: italic;
      margin-left: 16px;

      @media screen and (max-width: $break-large) {
        font-size: 14px;
        margin-left: 8px;
      }
    }
  }

  .deleteNewsButton {
    margin-top: 32px;
    background-color: red;
    color: white;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
